import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';
import VueGtag from 'vue-gtag';

import router from './router';

import store from '@/store';

var base_url = window.location.host;

store.dispatch('initialize', { base_url }).then( () => {
    // TODO
    // get gtm ID from api
    // disable by default
    // enable on consent

    let tagId = ( base_url === 'weinankauf.at' ) ? 'G-HXP8XHB07G' : 'G-5RKPGBF5K9';

    Vue.use(VueGtag, {
            config: {
                id: tagId
            }
        },
        router
    );

    Vue.use(VueGtm, {
        // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
        // or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
        id: ( base_url === 'weinankauf.at' ) ? 'AW-1015180163' : 'GTM-M65ZPXW',
        // queryParams: {
        //     // Add url query string when load gtm.js with GTM ID (optional)
        //     gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
        //     gtm_preview: 'env-4',
        //     gtm_cookies_win: 'x',
        // },
        defer: true, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
        enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
        debug: true, // Whether or not display console logs debugs (optional)
        loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
        vueRouter: router, // Pass the router instance to automatically sync with router (optional)
        // ignoredViews: ['homepage'], // Don't trigger events for specified router names (case insensitive) (optional)
        trackOnNextTick: true, // Whether or not call trackView in Vue.nextTick
    });
} );
